module.exports = __webpack_public_path__ + "fonts/Montserrat-BoldItalic.c645b431.ttf";